import { IPaymentOption } from '../../../../../models/event-payment-settings/event-payment-settings.interface'

export const paymentOptions: {
  key: IPaymentOption
  title: string
  subtitle: string
  tooltip: string
}[] = [
  {
    key: 'IncreaseAllPrices',
    title: 'Embed fees',
    subtitle: 'Increase all prices by 5% to cover Pegasus’ fee',
    tooltip:
      'Eg. $100 becomes $105. Riders & spectators pay 5% + 30c credit card processing fee. Organizer pays nothing.',
  },
  {
    key: 'ChargeRidersAndSpectators',
    title: 'Split fees',
    subtitle: 'Customers pay the 2.5%, Organizer pays 2.5%',
    tooltip:
      'Eg. $100 becomes $102.50. Riders & spectators pay 2.5% + 30c credit card processing fee. Organizer pays 2.5% fee when transferring funds to their bank account.',
  },
  {
    key: 'LeavePricesAsIs',
    title: 'Absorb fees',
    subtitle: 'Leave prices as they are. Organizer will pay 5% fee',
    tooltip:
      'Eg. $100 remains $100. Organizers pay 5% + 30c credit card processing fee when transferring funds to their bank account.',
  },
]
